import { render, staticRenderFns } from "./DraggableTreeview.vue?vue&type=template&id=1dcc5732"
import script from "./DraggableTreeview.vue?vue&type=script&lang=js"
export * from "./DraggableTreeview.vue?vue&type=script&lang=js"
import style0 from "./DraggableTreeview.vue?vue&type=style&index=0&id=1dcc5732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports